/**
 * GroundTruth Functions
 *
 * @see https://help.groundtruth.com/hc/en-us/articles/43656481694483-Install-GroundTruth-Pixel-Manually
 */

(function (pmw, undefined) {

	/**
	 * Load the GroundTruth Web Engagement Pixel
	 *
	 * Injects the standard GroundTruth snippet. The snippet defines window.gtpx as
	 * a queueing function immediately, so API calls made right after this still work.
	 * The pixel is initialized with the GTID and an explicit pageview is tracked,
	 * as recommended by GroundTruth for standard sites and SPAs.
	 */
	pmw.loadGroundTruthPixel = () => {
		try {
			// @formatter:off
			(function (g, r, o, u, n, d, t) {
				g[n] = g[n] || function () { (g[n].q = g[n].q || []).push(arguments); };
				g[n].l = 1 * new Date();
				t = r.createElement(o); t.async = 1; t.src = u;
				r.getElementsByTagName("head")[0].appendChild(t);
			})(window, document, "script", "https://analytics.groundtruth-data.com/pixel.v2.js", "gtpx");
			// @formatter:on

			// Initialize with the unique identifier (GTID)
			window.gtpx("init", {gtid: pmwDataLayer.pixels.groundtruth.gtid});

			// Explicitly track the pageview
			window.gtpx("pageview");

			pmwDataLayer.pixels.groundtruth.loaded = true;

			pmw.console.log("GroundTruth: pixel loaded");

		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Send an e-commerce signal to GroundTruth
	 *
	 * @param {Object} groundTruthData - Adapted GroundTruth data from the event payload
	 * @see https://help.groundtruth.com/hc/en-us/articles/43656481694483-Install-GroundTruth-Pixel-Manually
	 */
	pmw.groundTruthTrackEvent = (groundTruthData) => {
		try {
			if (typeof window.gtpx !== "function") return;
			if (!groundTruthData?.event_name) return;

			window.gtpx(groundTruthData.event_name, groundTruthData.event_data);

			pmw.console.log("GroundTruth: " + groundTruthData.event_name + " event sent", groundTruthData);

		} catch (e) {
			console.error(e);
		}
	};

}(window.pmw = window.pmw || {}));
